/* ========================================================
   REVEAL GLOBAL ANIMATION OBSERVER (V2 - OPTIMIZED)
======================================================== */
(function () {
  const initRevealAnimations = () => {
    const elements = document.querySelectorAll(
      ".reveal-animate:not(.is-animated)",
    );

    if (!("IntersectionObserver" in window)) {
      elements.forEach((el) => el.classList.add("is-animated"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-animated");
            obs.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 50px 0px 150px",
        threshold: 0,
      },
    );

    elements.forEach((el) => observer.observe(el));
  };

  // 1. Execução Inicial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRevealAnimations);
  } else {
    initRevealAnimations();
  }

  // 2. Suporte para o Editor do Shopify
  document.addEventListener("shopify:section:load", initRevealAnimations);

  // 3. MUTATION OBSERVER OTIMIZADO (Com Debounce)
  let debounceTimer;
  const dynamicObserver = new MutationObserver((mutations) => {
    let shouldRefresh = false;

    // Usar ciclo 'for' normal é mais rápido que 'forEach' em arrays grandes
    for (let i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        shouldRefresh = true;
        break; // Mal encontre um, para de procurar para poupar memória
      }
    }

    if (shouldRefresh) {
      clearTimeout(debounceTimer);
      // Espera 100ms depois da última mutação para correr o script apenas 1 vez
      debounceTimer = setTimeout(initRevealAnimations, 100);
    }
  });

  dynamicObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.RevealAnimations = {
    refresh: initRevealAnimations,
  };
})();
